import state from "../state";

export default {
   PRO_NAME:state=>state.PRO_NAME,
   PAGE_TITLE:state=>state.PAGE_TITLE,
   MENU_LIST:state=>state.MENU_LIST,
   DEGREE_LIST:state=>state.DEGREE_LIST,
   FINANCING_STATUS:state=>state.FINANCING_STATUS,
   COMPANY_SIZE:state=>state.COMPANY_SIZE,
   CITY_LIST:satte=>state.CITY_LIST,
   STATUS_LIST:state=>state.STATUS_LIST,
   CANDIDATE_STATUS:state=>state.CANDIDATE_STATUS,
   POSITION_LIST:state=>state.POSITION_LIST
}


// WEBPACK FOOTER //
// ./src/store/getters/index.js